import { required, TextInput } from "react-admin";
import { Grid } from "@mui/material";

const CreateForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameBg"
          label="Наименование (BG)"
          fullWidth
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameEn"
          label="Наименование (EN)"
          fullWidth
          validate={required()}
        />
      </Grid>
    </Grid>
  );
};

export default CreateForm;
